import React, {Component} from "react";
import {inject, observer} from "mobx-react";
import {Button, Col, Row , Input, InputGroup, Label} from "reactstrap";
import Card from "../../comum/components/Card";
import CalendarioPicker from "../../comum/components/Calendario";
import {FecharFiltro, Filtro} from "../../comum/components/Icones";
import SelectFiltro from "../../comum/components/SelectFiltro";
import FormNumberSimples from "../../comum/components/FormNumberSimples"

@inject("store")
@observer
export class FiltrosAnaliseCritica extends Component {
    constructor(props) {
        super(props);
        this.controllerAnalise = this.props.controllerAnalise;
        this.controller = this.props.controllerFiltro;
    };

    filtros = () => {
        return <Row className="pb-0">
                    <Col xl={3} lg={4} md={6} sm={12} xs={12} className={`mb-4`}>
                        <div className="w-100">
                            <Col xs={12} className="col-label px-0">
                                <Label>Período</Label>
                            </Col>
                            <Col xs={12} className="px-0">
                                <InputGroup className={'ativo'}>
                                    <CalendarioPicker onChangeInicio={event => this.controller.setFiltro('dataInicial', event)}
                                                      onChangeFim={event => this.controller.setFiltro('dataFinal', event)}
                                                      dataInicial={this.controller.filtro['dataInicial']}
                                                      dataFinal={this.controller.filtro['dataFinal']}
                                                      filtrar={() => {}}  />
                                </InputGroup>
                            </Col>
                        </div>
                    </Col>
                    { this.controller.maisFiltros &&
                        <React.Fragment>
                            <FormNumberSimples 
                                xl={2} lg={4} md={6} sm={12} xs={12}
                                titulo="Código"
                                onEnter={() => this.handleFiltrar()}
                                onChange={event => this.controller.setFiltro('codigo', event)} type="number"
                            />
                            <FormNumberSimples
                                xl={2} lg={4} md={6} sm={12} xs={12}
                                titulo="NCM"
                                onEnter={() => this.handleFiltrar()}
                                onChange={event => this.controller.setFiltro('ncm', event)} type="number"
                            />
                            <SelectFiltro xl={2} lg={4} md={6} sm={12} xs={12}
                                titulo="Situação"
                                itens={this.controller.statusOptions}
                                valor={this.controller.filtro['status']}
                                itensValor="Id.RvLowValue" itensLabel="RvMeaning"
                                onChange={event => this.controller.setFiltro('status', event)}/>
                        </React.Fragment>
                    }
                    { this.acoesFiltro() }
               </Row>
    };

    acoesFiltro(){
        return  <Col className="col-botoes align-items-end mb-4" xl={3} lg={4} md={6} sm={12} xs={12}>
                    { this.botaoExpandir() }
                    <Button className="btn-com-bordas-primary btn-filtrar" onClick={ () => this.handleFiltrar() }>Filtrar</Button>
                </Col>
    }

    botaoExpandir = () => {
        return <Button className={`btn-filtros ${this.controller.maisFiltros && 'ativo'}`} onClick={ () => this.expandirFiltros() } outline >
                { this.controller.maisFiltros ?
                    <div><FecharFiltro color="#93A0AD" className="mr-2" width="15" height="15"/> Menos filtros</div>
                    :
                    <div><Filtro color="#93A0AD" className="mr-2" width="15" height="15"/> Mais filtros</div>
                }
               </Button>;
    };

    expandirFiltros(){
        this.controller.alternarFiltros();
    }

    handleFiltrar(){
        this.controllerAnalise.carregarAnalises(this.controller.filtro);
    }

    render() {
        return(
            <div className="filtros filtro-analise-critica">
                <Card className={`area-form pb-0`}>
                    { this.filtros() }
                </Card>
            </div>)
    }
}


// WEBPACK FOOTER //
// ./src/modules/analise/components/FiltrosAnaliseCritica.js